import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import firebase from '../../Firebase/firebase';
import { logActivity, allowedUsers } from '../Utilities';
class Login extends Component {

  state = {
    email: '',
    password: '',
    error: null,
  };

  componentDidMount = () => {
    // logActivity([
    //   {
    //     "screen": "Login",
    //     "module": "Login Page",
    //     "user_activity": "user login",
    //     "timestamp": new Date().toISOString()
    //   }
    // ])
  }

  handleInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  resentPass = (event) => {
    event.preventDefault()
    firebase
      .auth().sendPasswordResetEmail()
  }

  handleSubmit = (event) => {
    // check users
    const userLen = allowedUsers.length
    var isUserAllowed = false
    for (let i = 0; i < userLen; i++) {
      if (this.state.email === allowedUsers[i]) {
        isUserAllowed = true
        break
      }
    }
    if (isUserAllowed) {
      event.preventDefault();
      const { email, password } = this.state;

      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((user) => {
          console.log(user.user.uid)
          sessionStorage.setItem('user_email', this.state.email)
          console.log(firebase.auth().currentUser.getIdToken(true))
          localStorage.setItem("accessToken", firebase.auth().currentUser.getIdToken(true))

        })
        .catch((error) => {
          this.setState({ error: error });
        });
    }
    else {
      alert('You have no access to use this application')
    }
  };
  render() {
    const { email, password, error } = this.state;
    return (
      <div className="container-fluid" style={{ width: '50%' }}>
        <div className="row">
          <div className="col-12">
            <h4>Log In</h4>
          </div>
        </div>
        {error ? (
          <div className="row">
            <div className="col-12">
              <span>{error.message}</span>
            </div>
          </div>
        ) : null}
        <div className="row">
          <div className="col-12">
            <form onSubmit={this.handleSubmit} className="form-group">
              <input type="text" name="email" className="form-control" placeholder="Email" value={email} onChange={this.handleInputChange} />
              <br />   <input
                type="password"
                name="password"
                placeholder="Password"
                value={password}
                onChange={this.handleInputChange}
                className="form-control"
              /><br />
              <button className="btn btn-primary">Log In</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
